const PlayerPositionCategory = Object.freeze({
    DEFENSE: "Defense",
    OFFENSE: "Offense",
    PASSING: "Passing",
    RUSHING: "Rushing",
    RECEIVING: "Receiving",
    KICKING: "Kicking",
    PUNTING: "Punting"
});

export default PlayerPositionCategory;
